import { render, staticRenderFns } from "./search-bar.vue?vue&type=template&id=6278e961&scoped=true&"
import script from "./search-bar.vue?vue&type=script&lang=ts&"
export * from "./search-bar.vue?vue&type=script&lang=ts&"
import style0 from "./search-bar.vue?vue&type=style&index=0&id=6278e961&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6278e961",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/aef.slmndr.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6278e961')) {
      api.createRecord('6278e961', component.options)
    } else {
      api.reload('6278e961', component.options)
    }
    module.hot.accept("./search-bar.vue?vue&type=template&id=6278e961&scoped=true&", function () {
      api.rerender('6278e961', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/estates/search-bar.vue"
export default component.exports